import { render, staticRenderFns } from "./footer-primary.vue?vue&type=template&id=f1b77e30&scoped=true&"
import script from "./footer-primary.vue?vue&type=script&lang=js&"
export * from "./footer-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b77e30",
  null
  
)

export default component.exports